import { Injectable } from '@angular/core';
import io, { Socket } from 'socket.io-client';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Refers to Core API Socket.io service.
 */

@Injectable({
  providedIn: 'root',
})
export class CoreSocketService {
  private socket: Socket;
  private connected$ = new BehaviorSubject<boolean>(false);
  private error$ = new Subject<string>();

  constructor() {}

  public get connectionStatus() {
    return this.connected$.asObservable();
  }

  public get error() {
    return this.error$.asObservable();
  }

  public onEvent(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (val: any) => {
        subscriber.next(val);
      });
    });
  }

  public emitEvent(eventName: string, data?: any): Observable<any> {
    return this.socket.emit(eventName, data);
  }

  public clearListener() {
    this.socket.off();
  }

  public initSocket() {
    const socketURL = new URL(
      environment.type !== 'dev' ? 'https://queue.periksa.tech' : `${environment.urlV2}`
    );

    this.socket = io(socketURL.origin, {
      upgrade: true,
      path: '/socket.io',
      transports: ['websocket'],
      autoConnect: true,
      timeout: 3600000,
    });

    this.socket.on('connect', (conn) => {
      this.connected$.next(true);
    });

    this.socket.on('connect_error', (err) => {
      console.warn('error', err.message);
      this.connected$.next(false);
      this.error$.next(err);
    });

    this.socket.on('disconnect', (data) => {
      console.warn('disconnect', data);
      this.connected$.next(false);
    });
  }

  public reconnect(): void {
    if (this.socket?.connected) {
      this.socket.disconnect();
    }
    this.initSocket();
  }
}
